/**
 * Scrollable tab body — uses the feathers ScrollArea for styled scrollbars.
 * overscroll-contain prevents WebKit bounce in the Office task pane host.
 * data-tab-scroll-area hooks the index.css rule that keeps the Radix content
 * wrapper from growing past the pane width (vertical scrolling only).
 */

import React from 'react';
import { ScrollArea } from '@e14c/feathers';

interface TabScrollAreaProps {
  children: React.ReactNode;
  className?: string;
}

export const TabScrollArea: React.FC<TabScrollAreaProps> = ({
  children,
  className,
}) => (
  <ScrollArea
    data-tab-scroll-area
    className={`flex-1 h-0 min-h-0 overscroll-contain ${className ?? ''}`}
    role="region"
    aria-label="Tab content"
  >
    <div className="px-4 py-3 space-y-3">{children}</div>
  </ScrollArea>
);
